import _ from 'lodash';
import {EventEmitter} from 'events';

const speed = 0.25 / 1000;

class IntroSoundWaveProvider extends EventEmitter {
    timer = null;
    dataArray = new Uint8Array(512);
    soundTime = 0;
    startTime = -1;
    started = false;

    on(...args) {
        super.on(...args);
        this.start();
    }

    removeListener(...args) {
        super.removeListener(...args);
        this.stop();
    }

    start() {
        this.startTime = Date.now();
        this.started = true;
        requestAnimationFrame(this.emitData);
    }

    emitData = () => {
        this.soundTime = Date.now() - this.startTime;

        if (!this.started) {
            return;
        }

        this.updateDataArray();
        this.emit('data', this.dataArray);

        requestAnimationFrame(this.emitData);
    };

    updateDataArray() {
        const N = this.dataArray.length;
        const k = 2 * Math.PI * 8;

        const z = Math.abs((this.soundTime % 2000) / 2000 - 0.5);
        const A = 0.5 - 0.571 * z * z;
        const B = 0.4 - 0.231 * z * z * z;
        const v = speed;

        for (let i = 0; i < N; i++) {
            const phase = i / N + v * this.soundTime;
            const value = A * Math.sin(k * phase) + B * Math.cos(0.5 * k * phase);
            this.dataArray[i] = 128 + 127 * value;
        }
    }

    stop() {
        this.started = false;
    }
}

export default () => new IntroSoundWaveProvider();
